import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { InboxModule } from '../inbox/inbox.module';
import { PseudoMassActionsComponent } from './components/feature-tour/pseudo-mass-actions/pseudo-mass-actions.component';
import { StepPopoverComponent } from './components/feature-tour/step-popover/step-popover.component';
import { NothingToSearchComponent } from './components/nothing-to-search/nothing-to-search.component';
import { SearchResultsComponent } from './search-results/search-results.component';
import { SearchComponent } from './search.component';
import { FeatureTourService } from './shared/feature-tour.service';

@NgModule({
  declarations: [
    NothingToSearchComponent,
    PseudoMassActionsComponent,
    SearchComponent,
    SearchResultsComponent,
    StepPopoverComponent,
  ],
  imports: [CommonModule, InboxModule, SharedModule],
  providers: [FeatureTourService],
})
export class SearchModule {}
